import { render, staticRenderFns } from "./ContactsEdit.vue?vue&type=template&id=2c6603b2&"
import script from "./ContactsEdit.vue?vue&type=script&lang=js&"
export * from "./ContactsEdit.vue?vue&type=script&lang=js&"
import style0 from "./ContactsEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports